import starIcon from '@app/layouts/html/assets/img/icon-1.png'
import notifyIcon from '@app/layouts/html/assets/img/icon-2.png'
import cakeIcon from '@app/layouts/html/assets/img/icon-3.png'
import coffeIcon from '@app/layouts/html/assets/img/icon-4.png'
import knifeIcon from '@app/layouts/html/assets/img/icon-5.png'
import dumplingsIcon from '@app/layouts/html/assets/img/icon-6.png'
import breadIcon from '@app/layouts/html/assets/img/icon-7.png'
import steakIcon from '@app/layouts/html/assets/img/icon-8.png'
import ramenIcon from '@app/layouts/html/assets/img/icon-9.png'
import takeOutIcon from '@app/layouts/html/assets/img/icon-10.png'
import cartIcon from '@app/layouts/html/assets/img/icon-11.png'
import otherIcon from '@app/layouts/html/assets/img/icon-12.png'
import hotelIcon from '@app/layouts/html/assets/img/ic_cate_group_10.png'

export const getIconByName = (foodCateName: string) => {
  let result = ''
  switch (foodCateName) {
    default:
      result = otherIcon
      break
    case '高評価':
      result = starIcon
      break
    case '子連れ歓迎店':
      result = notifyIcon
      break
    case 'スイーツ・和菓子':
      result = cakeIcon
      break
    case 'カフェ・パン':
      result = coffeIcon
      break
    case 'バー・レストラン':
      result = knifeIcon
      break
    case '餃子・中華':
      result = dumplingsIcon
      break
    case 'テイクアウト・小売店':
      result = breadIcon
      break
    case '和食・居酒屋':
      result = steakIcon
      break
    case '焼肉・ステーキ':
      result = ramenIcon
      break
    case '麺類・ラーメン':
      result = takeOutIcon
      break
    case '取り寄せグルメ':
      result = cartIcon
      break
    case 'その他':
      result = hotelIcon
      break
  }
  return result
}
